// ============================================================
// หน้า Import — เมนูเลือกประเภทไฟล์ที่จะนำเข้า
// ------------------------------------------------------------
// เป็นแค่หน้าเลือกทาง ไม่มีตรรกะอะไร กดการ์ดแล้วไปหน้านำเข้าของแต่ละประเภท
// ============================================================

import React, { Component } from "react";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import { loading, ICON } from "../../shared/index.js";

// ประเภทไฟล์ที่นำเข้าได้
const IMPORT_TYPES = [
  { icon: ICON.user, label: "รายชื่อลูกค้า", link: "/import-customer" },
  { icon: ICON.map_marker, label: "การแจ้งหนี้และจัดเก็บค่าน้ำ", link: "/import-bill-water" },
  { icon: ICON.map_marker, label: "การแจ้งหนี้และจัดเก็บค่าน้ำ (แบบไม่มีเลขมาตรเริ่มต้น - สิ้นสุด)", link: "/import-bill-unit-used" },
];

export default class Import extends Component {
  componentDidMount() {
    loading(false);
  }

  render() {
    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="นำเข้าไฟล์ข้อมูล" />

        <div className="body">
          <div className="p-3">
            <h4 className="mb-3">
              <b>นำเข้าไฟล์ข้อมูล</b>
            </h4>
            <div className="card border-0 p-3 mb-3">
              <div className="bg-light card py-5 border-dashed">
                <div className="d-flex row w-100 justify-content-center my-5">
                  {IMPORT_TYPES.map((item, index) => (
                    <div key={index} className="card shadow mx-2 p-3 text-center wpx-200 pointer mb-3" onClick={() => (window.location.href = item.link)}>
                      <b className="icon text-primary" style={{ fontSize: 32 }}>
                        {item.icon}
                      </b>
                      <label className="pointer">{item.label}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
